import { Controller } from "@hotwired/stimulus";
import {
  fetchTotalPrice,
  fetchPreviewPrice,
} from "frontoffice/services/bookingService";

export default class extends Controller {
  static targets = ["totalPrice"];

  static values = {
    bookingId: Number,
  };

  connect() {
    this.boundHandlePriceUpdate = this.handlePriceUpdate.bind(this);
    document.addEventListener(
      "booking-price-update-needed",
      this.boundHandlePriceUpdate
    );

    this.boundHandlePriceReset = this.handlePriceReset.bind(this);
    document.addEventListener(
      "booking-price-reset-needed",
      this.boundHandlePriceReset
    );
  }

  disconnect() {
    if (this.boundHandlePriceUpdate) {
      document.removeEventListener(
        "booking-price-update-needed",
        this.boundHandlePriceUpdate
      );
    }
    if (this.boundHandlePriceReset) {
      document.removeEventListener(
        "booking-price-reset-needed",
        this.boundHandlePriceReset
      );
    }
  }

  handlePriceUpdate(event) {
    const { bookingId, formSelections } = event.detail;

    if (bookingId === this.bookingIdValue) {
      this.updatePricePreview(formSelections);
    }
  }

  handlePriceReset(event) {
    const { bookingId } = event.detail;

    if (bookingId === this.bookingIdValue) {
      this.resetPriceDisplay();
    }
  }

  updatePricePreview(formSelections = null) {
    console.log(
      "[EditBooking] updatePricePreview called with formSelections:",
      formSelections
    );
    console.log(
      "[EditBooking] formSelections as string:",
      formSelections ? formSelections.toString() : "null"
    );
    console.log(
      "[EditBooking] Current totalPriceTarget.innerHTML:",
      this.totalPriceTarget?.innerHTML
    );
    console.log(
      "[EditBooking] totalPriceTarget element:",
      this.totalPriceTarget
    );

    const success = (response) => {
      console.log("[EditBooking] Price update SUCCESS - response:", response);
      console.log("[EditBooking] Response type:", typeof response);
      console.log(
        "[EditBooking] Before update - innerHTML:",
        this.totalPriceTarget.innerHTML
      );
      this.totalPriceTarget.innerHTML = response;
      console.log(
        "[EditBooking] After update - innerHTML:",
        this.totalPriceTarget.innerHTML
      );

      // Check again after a delay to see if something overwrites it
      setTimeout(() => {
        console.log(
          "[EditBooking] 100ms later - innerHTML:",
          this.totalPriceTarget.innerHTML
        );
      }, 100);
    };
    const error = (xhr, status, errorMessage) => {
      console.error("[EditBooking] Price update ERROR:", {
        xhr,
        status,
        errorMessage,
      });
    };

    fetchPreviewPrice({
      id: this.bookingIdValue,
      formSelections,
      success,
      error,
    });
  }

  resetPriceDisplay() {
    console.log("[EditBooking] resetPriceDisplay called");
    console.log(
      "[EditBooking] Before reset - innerHTML:",
      this.totalPriceTarget.innerHTML
    );
    this.totalPriceTarget.innerHTML =
      '<div class="text-gray-500">ab 0,00€</div>';
    console.log(
      "[EditBooking] After reset - innerHTML:",
      this.totalPriceTarget.innerHTML
    );
  }

  updatePrice() {
    const success = (response) => {
      this.totalPriceTarget.innerHTML = response;
    };
    const error = () => {};

    fetchTotalPrice({
      id: this.bookingIdValue,
      success,
      error,
    });
  }
}
